import React, { Component } from 'react';
import { Card } from 'antd';
import { connect } from 'react-redux';

import DescriptionList from '@comm/DescriptionList';
import util from '@util/index';
import TableFile from '../comm/TableFile';
import TablePayable from '../comm/TablePayable';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleVisible = flag => {};

  handleSeatVisible = flag => {};

  render() {
    const { dataItem } = this.state;
    return (
      <div className="form-open mb16">
        <Card title="账单退款详情">
          <DescriptionList size="large" col={1}>
            <Description term="付款公司">{dataItem.company}</Description>
            <Description term="客户名称">{dataItem.custom}</Description>
            <Description term="账单列表">
              <TablePayable dataSource={dataItem.payables || []} disabled />
            </Description>
            <Description term="退款金额">{util.numberFormat(dataItem.price)}</Description>
            <Description term="公司抬头">{dataItem.accountName}</Description>
            <Description term="银行账号">{dataItem.account}</Description>
            <Description term="开户行">{dataItem.accountBank}</Description>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
            <Description term="退款说明">{dataItem.reason}</Description>
          </DescriptionList>
        </Card>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/back/FormOpen.js